// extracted by mini-css-extract-plugin
export default {"wrapper":"LoadingScreen_wrapper__5PhcX","pulse":"LoadingScreen_pulse__xRzUs","hide":"LoadingScreen_hide__YqVkH","fadeOut":"LoadingScreen_fadeOut__Lx3Y1"};